module.exports = __webpack_public_path__ + "step3_parent_to_child.d3875fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step3_parent_to_child.jpg
// module id = uXGd
// module chunks = 0